/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgSendIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.536 21.686C14.3627 22.0498 13.8831 22.0869 13.6585 21.7533L9.1573 15.0648C9.06498 14.928 9.07205 14.7463 9.17475 14.6167L14.4658 8.05086C14.6436 7.82824 14.355 7.5551 14.1414 7.7445L8.0737 13.1202C7.94727 13.2322 7.7687 13.2454 7.6293 13.1534L1.25019 9.10746C0.908585 8.89046 0.935265 8.39512 1.29849 8.21454L22.1506 2.18921C22.5355 2.0005 22.9275 2.38505 22.7491 2.77456L14.536 21.686Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgSendIcon;
